import { SliceCaseReducers, createSlice, nanoid } from '@reduxjs/toolkit';
import { BD100_PAGES, BD100Pages } from 'app/components/BD100';

export interface IBD100State {
  page: BD100Pages;
}

export const slice = createSlice<IBD100State, SliceCaseReducers<IBD100State>>({
  name: 'bd-100',
  initialState: {
    page: BD100_PAGES.OPPORTUNITIES,
  },
  reducers: {
    setPage: (state, action: { payload: BD100Pages }) => {
      state.page = action.payload;
    },
  },
});

export const { setPage } = slice.actions;

export const pageSelector = (state: { bd100: IBD100State }) => state.bd100.page;

export default slice.reducer;
